<template>
  <div class="is-preload main-div">
    <page-header></page-header>

    <div class="sign-action-container" v-if="viewMode == 'main'">
      <button @click="changeView('signin')" class="sign-in" value="Sign In"> Sign In</button>
      <button @click="changeView('signup')" class="sign-up" value="Sign Up"> Sign Up</button>
    </div>

    <div class="sign-action-container" v-if="viewMode == 'signin'" style="margin-bottom: -3em">
      <div class="field-container-2">
        <label>Company</label>
        <input type="text" v-model="identity">
        <label class="error" v-if="login_company_errors">{{ login_company_errors }}</label>
      </div>


      <div class="field-container-2">
        <label>Password</label>
        <input type="password" v-model="passPhrase">
        <label class="error" v-if="login_password_errors">{{ login_password_errors }}</label>
      </div>

      <button @click="authenticate" class="register" value="Sign Up"> Login <i class="fa fa-arrow"></i></button>
      <br>
      <button @click="changeView('main')" class="back"><i class="fa fa-arrow-left"></i> Back</button>
    </div>

    <div class="sign-action-container" v-if="viewMode == 'signup'" style="margin-bottom: -3em">
      <div class="field-container">
        <label>Company</label>
        <input type="text" v-model="company">
        <label class="error" v-if="company_errors">{{ company_errors }}</label>
      </div>


      <div class="field-container">
        <label>Email</label>
        <input type="text" v-model="email">
        <label class="error" v-if="email_errors">{{ email_errors }}</label>
      </div>

      <div class="field-container">
        <label>Password</label>
        <input type="password" v-model="password">
        <label class="error" v-if="password_errors">{{ password_errors }}</label>
      </div>

      <div class="field-container">
        <label>Confirm Password</label>
        <input type="password" v-model="confirm_password">
        <label class="error" v-if="confirm_password_errors">{{ confirm_password_errors }}</label>
      </div>

      <div class="field-container">
        <label>Country</label>
        <SelectCountriesList @amUpdated="countryUpdated"></SelectCountriesList>
        <label class="error-2" v-if="country_errors">{{ country_errors }}</label>
      </div>

      <div class="field-container">
        <label>Package</label>
        <select v-model="subscription_plan">
          <option :key="key" :value="plan.value" v-for="(plan, key) in subscribePlansList">{{ plan.label }}</option>
        </select>
        <label class="error-2" v-if="subscription_plan_errors">{{ subscription_plan_errors }}</label>
      </div>

      <div class="field-container">
        <label>By signing up <b>You</b> agree on MyRoutetester <a href="privacy-policy.html">Privacy Policy</a> and <a href="terms-conditions.html">Terms Conditions</a></label>
        <label class="error" v-if="terms_errors">{{ terms_errors }}</label>
      </div>

      <button @click="changeView('main')" class="back"><i class="fa fa-arrow-left"></i> Back</button>
      <button @click="signup" class="register"> Register <i class="fa fa-arrow"></i></button>
    </div>

    <footer id="footer">
      <ul class="icons">
        <li><a class="icon brands fa-twitter" href="#"><span class="label">Twitter</span></a></li>
        <li><a class="icon brands fa-instagram" href="#"><span class="label">Instagram</span></a></li>
        <li><a class="icon brands fa-github" href="#"><span class="label">GitHub</span></a></li>
        <li><a class="icon fa-envelope" href="#"><span class="label">Email</span></a></li>
      </ul>
      <ul class="copyright">
        <li>&copy; MyRouteTester.</li>
        <li>Powered By: <a href="https://jikatel.com">Jikatel</a></li>
      </ul>
    </footer>
    <paymentForm :amt="amtPayment" :packageName="packageName" :customData="customData" v-if="registrationCompleted"></paymentForm>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import iziToast from "izitoast";

export default {
  components: {
    SelectCountriesList: () => import('@/components/SelectCountriesList'),
    paymentForm: () => import('./PaymentForm'),
    pageHeader: () => import('./comps/nav/View'),
  },
  async beforeMount() {
    this.getSubscriptionPlansList().then(r => {
      this.subscribePlansList = r
    })
    if (!$store.hasModule('user-mrt-features-api')) {
      let {default: importedModule} = await import('@/modules/user-mrt-features/store/api.js')
      $store.registerModule('user-mrt-features-api', importedModule)
    }
  },
  data() {
    return {
      identity: null,
      passPhrase: null,
      login_company_errors: false,
      login_password_errors: false,
      viewMode: 'main',
      packageName: '',
      amtPayment: null,
      customData: '',
      registrationCompleted: false,
      isSelectedUserMrt: true,
      formIsValid: false,
      form_error_message: false,
      subscribePlansList: [],
      company: '',
      email: '',
      password: '',
      confirm_password: '',
      subscription_plan: '',
      country: false,
      terms: false,
      company_errors: false,
      email_errors: false,
      password_errors: false,
      confirm_password_errors: false,
      terms_errors: false,
      country_errors: false,
      subscription_plan_errors: false
    }
  },
  methods: {
    authenticate() {
      $store.dispatch('user-api/login', {
        identityPassport: this.identity,
        secret: this.passPhrase,
      }).then((r) => {
        this.halfOpacity = true
        iziToast.success({
          title: 'Authenticated',
          message: 'Your dashboard is ready',
          position: 'topRight',
          close: false,
          timeout: 800,
          animateInside: true,
          onClosed: () => {
          }
        })
        setTimeout(() => {
          //window.location = $router.resolve({name: 'portal-cpanel'}).resolved.fullPath;
          $router.push({name: 'portal-cpanel'})
          localStorage.removeItem('redirected_to_login')
        }, 900)
      }).catch((e) => {
        iziToast.warning({
          title: 'Caution',
          message: 'You have to check your credentials',
          position: 'topRight',
          timeout: 1500,
          animateInside: true,
          close: false,
        });
      })
    },
    changeView(mode) {
      this.viewMode = mode
    },
    ...mapActions('user-mrt-features-api', {
      prepareNewMrtFields: 'create',
    }),
    ...mapActions('user-api', {
      getSubscriptionPlansList: 'getUserSubscriptionPlansList'
    }),
    checkRequired (fieldName) {
      this[fieldName + '_errors'] = false
      if (!this[fieldName]) {

        this[fieldName + '_errors'] = 'This field is required'
        this.formIsValid = false
      }
    },
    countryUpdated (val) {
      this.country = val
    },
    signup() {

      this.formIsValid = true
      this.form_error_message = ''

      let apiData = {
        data: {
          company: this.company,
          email: this.email,
          password: this.password,
          confirm_password: this.confirm_password,
          country: this.country,
          subscription_plan: this.subscription_plan,
          // terms: this.terms
        }
      }

      for(let f in apiData.data) {
        this.checkRequired(f)
      }

      if (this.password != this.confirm_password) {
        this.confirm_password_errors = 'Password do not match'
        return
      }

      if (!this.formIsValid) {
        this.form_error_message = 'check fields errors'
        return
      }

      let api = 'registerNewMRTUser'

      this.$store.dispatch('user-mrt-features-api/' + api, apiData).then(response => {
        this.selectedProfileId = 7 // MRT Profile
        let createdUserId = response.data.user_id

        this.customData = createdUserId + '-' + response.data.subscription_payment_id + '-' + apiData.data.country + '-' + ''
        this.amtPayment = response.data.amt
        this.packageName = response.data.plan_name
        this.registrationCompleted = true

        iziToast.success({
          title: 'Signup Successfully',
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true
        });

      }).catch(error => {
        if (error.response.status == 400) {
          iziToast.warning({
            title: 'Please check your fields',
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true
          });

          let data = error.response.data;

          if (data.username) {
            this.company_errors = 'This company name is already registered'
          }

          if (data.email) {
            this.email_errors = 'This email address is already registered'
          }
        } else {
          iziToast.error({
            title: 'Please Contact Administration',
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true
          });
        }
      })
    }
  }
}
</script>


<style scoped>
.grid-specs {
  grid-template-columns: 4fr 1fr;
}

.main-div {
  padding: 6em 4em 4em 4em;
  display: flex;
  -moz-flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  background-color: transparent;
  padding: 1em 4em 4em 4em;
  color: rgba(255, 255, 255, 0.75);
  font-family: "Roboto", sans-serif;
  font-size: 16pt;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.65em;
}

.sign-action-container {
  text-align: left;
}

.sign-action-container input, .sign-action-container select {
  margin-left: 20px;
  margin-bottom: 20px;
  width: 300px;
  padding: 10px;
  font-size: 14pt;
}

.sign-action-container button {
  width: 150px;
  color: rgba(255, 255, 255, 0.75);
  font-family: "Roboto", sans-serif;
  font-size: 16pt;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.65em;
}

.sign-action-container button.back {
  margin: 0 0 0 20px;
}
.sign-action-container button.sign-in, .sign-action-container button.back {
  color: #fff !important;
  border: 1px solid rgba(255, 255, 255, .2);
  background-color: rgba(255, 255, 255, .2);
}

.sign-action-container button.sign-in:hover, .sign-action-container button.back:hover {
  border: 1px solid rgba(42, 183, 180, .9);
  background-color: rgba(42, 183, 180, .9);
}

.sign-action-container button.sign-up {
  background-color: #2ab7b4;
  margin-left: 20px;
}

.sign-action-container button.register {
  margin-left: 20px;
}

.sign-action-container button.sign-up:hover {
  background-color: rgba(42, 183, 180, .6);
}

.field-container, .field-container-2 {
  height: 150px;
  position: relative;
}

.field-container {
  margin-bottom: 20px;
  width: 500px;
  display: inline-block;
}

.field-container-2 {
  margin-bottom: 20px;
  width: 350px;
  display: inline-block;
}

.field-container label, .field-container select, .field-container-2 label {
  margin: 0 0 0 20px;
}

.field-container .error, .field-container-2 .error {
  position: absolute;
  top: 90px;
  left: 2px;
  color: rgba( 230, 117, 89, 0.9) !important;
}

.field-container .error-2, .field-container-2 .error-2 {
  position: absolute;
  top: 90px;
  left: 2px;
  color: rgba( 230, 117, 89, 0.9) !important;
}


@media only screen and (max-width: 600px) {
  .logo {
    margin-bottom: 20px;
  }
}
</style>
